import React from "react";
import "../../../css/MonthTransSubsc.css";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  YAxis,
  ResponsiveContainer,
} from "recharts";

interface MonthTransSubscProps {
  MonthTransSubsc: { month: string; subsc: string | number; auth: string }[];
}

const MonthTransSubsc = ({ MonthTransSubsc }: MonthTransSubscProps) => {
  return (
    <div className="month_subsc_trans_container">
      <h2 className="month_subsc_trans_title">月ごとの登録者推移</h2>
      <ResponsiveContainer
        height="75%"
        width="90%"
        minHeight={240}
        minWidth={300}>
        <LineChart data={MonthTransSubsc} className="line_chart">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis dataKey="subsc" />
          <YAxis dataKey="auth" />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="subsc"
            stroke="#82ca9d"
            name="登録者数"
          />
          <Line
            type="monotone"
            dataKey="auth"
            stroke="#8884d8"
            name="認証終了者数"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthTransSubsc;
